import React, { useRef } from "react";
import UInput from "ubs-framework/v2/UInput";
import { clearValidation } from "ubs-framework/v2/common/function";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const OptionSelector = ({ title, options = [], mainKey, selected = [], onSelect, multiSelect = false, formData, setFormData, validator }) => {

  const isSelected = (label) =>
    Array.isArray(selected) && selected.some((o) => o.label === label);

  const handleClick = (option) => {
    if (multiSelect) {
      onSelect(mainKey, option, true);
    } else {
      if (option.label !== "Other") clearValidation(validator, ["other"]);
      onSelect(mainKey, option, false);
    }
  };

  const handleOtherChange = (e) => {
    const updatedValue = e.target.value;
    const updatedItem = { label: "Other", value: updatedValue, key: mainKey };
  
    if (multiSelect) {
      const current = Array.isArray(formData[mainKey]) ? formData[mainKey] : [];
      const exists = current.some((o) => o.label === "Other");
  
      const newList = exists
        ? current?.map((o) =>
            o.label === "Other" ? { ...o, value: updatedValue } : o
          )
        : [...current, updatedItem];
  
      setFormData({ ...formData, [mainKey]: newList });
    } else {
      setFormData({ ...formData, [mainKey]: [updatedItem] });
    }
  };

  const selectedOther =
    Array.isArray(selected) && selected.find((s) => s.label === "Other");

  return (
    <div className="u_option-section u_mb-32">
      <h4 className="u_title u_text-center u_text-bold u_mt-16 u_mb-20">
        {title}
      </h4>
      <div className="u_row u_select-options u_content-center u_mb-16">
        {options?.map((option) => (
          <div key={option.label} 
            className={`u_label u_mb-16 u_py-10 u_px-20 u_border-radius-6 u_mx-4 u_cp ${isSelected(option.label) ? "active" : ""}`} onClick={() => handleClick(option)} 
          >
            <p className="u_small-font u_color-title u_fw-500">
              {option.label}
            </p>
          </div>
        ))}
      </div>
      {selectedOther && (
        <div className="u_row u_content-center">
          <div className="u_col-6">
            <UInput
              hasError={validator.current.message(
                "other",
                selectedOther?.value,
                "required|between:1,80,string"
              )}
              className="u_mb-20"
              label="Other"
              asterisk
              testId={TEST_ID.OPTION_SELECTOR.INPUT_WRAPPER}>
              <input
                name="other"
                placeholder=" "
                value={selectedOther?.value || ""}
                onChange={handleOtherChange}
                data-testid={TEST_ID.OPTION_SELECTOR.OTHER_INPUT} />
            </UInput>
          </div>
        </div>
      )}
    </div>
  );
};

export default OptionSelector;
